/** 카드 가격 표시용: "10,000원". CardTable/StockTable/DropReviewModal이 공유한다. */
export const formatPrice = (n: number) => `${n.toLocaleString('ko-KR')}원`;

/** 매입 금액 표시용(₩ 접두, null-safe): 값 없으면 ₩0(단가·소계처럼 "값 없음 = 0"인 곳). */
export const formatWon = (n: number | null | undefined) => `₩${(n ?? 0).toLocaleString('ko-KR')}`;

/** 매입 총액처럼 "아직 집계 전"과 "0원"을 구분해야 하는 곳: 값 없으면 '-'. */
export const formatWonOrDash = (n: number | null | undefined) =>
  n == null ? '-' : `₩${n.toLocaleString('ko-KR')}`;

// Ant Design InputNumber의 formatter/parser에 그대로 넘기는 천단위 콤마 변환용 정규식.
// CardTable/DropReviewModal의 가격 입력 필드가 공유한다 — 각 컴포넌트 안에 두면 키 입력마다
// 새 RegExp가 만들어진다.
const THOUSANDS_SEPARATOR_RE = /\B(?=(\d{3})+(?!\d))/g;
const DIGIT_GROUP_COMMA_RE = /,/g;

/** InputNumber formatter: 1000 → "1,000" */
export const formatThousands = (v: string | number | undefined) => `${v}`.replace(THOUSANDS_SEPARATOR_RE, ',');

/** InputNumber parser: "1,000" → 1000 */
export const parseThousands = (v: string | undefined) => (v ? Number(v.replace(DIGIT_GROUP_COMMA_RE, '')) : 0);
